import { useModal } from "modules";

export const useShowUnderwritingWaitTimeModal = () => {
  const openModal = useModal();

  const showUnderwritingWaitTimeModalCommand = () => {
    openModal("UnderwritingWaitTimeModal");
  };

  return showUnderwritingWaitTimeModalCommand;
};
